module.exports = __webpack_public_path__ + "img/IMAGE3MESINOFFSET2.0939a066.jpeg";